export default __webpack_public_path__ + "static/media/06biracarvalho0012_edited.7cefbbf7.jpg";